import * as React from "react";

import { Divider, Flex } from "@theorgchartdev/storybook";
import { DataSetupInputComposite } from "../DataSetupInputComposite";
import AdditionalTableFieldToggleMenu from "../AdditionalTableFieldToggleMenu";
import { SourceMapComposite } from "../SourceMapComposite";
import { appstr } from "@coreapp/utils/appstr";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { kebabCase } from "@/Utils/formatters";

export const enumATSModes = { notATS: 0, pureATS: 1, toggleATS: 2, nonConfigurableATS: 3 };

export const DataSourceSetupComposite = ({
  config,
  children,
  inputOptions,
  chartConfig,
  index,
  doInputLookup = true,
  showInputControls,
  postInputControlsNode = null,
  showCustomFields,
  showAdditionalFields,
  customFieldOptions,
  onCustomFieldChange,
  additionalFieldOptions,
  selectedAdditionalFields,
  onAdditionalFieldChange,
  selectedCustomFields,
  showConfiguration,
  onChange,
  sourceMapProps,
  showLoadHeaders, // The load headers button should not be present in the import dialog.
  importType,
  ATSType
}) => {
  let firstKey = "PersonID";
  let secondKey = "SupervisorID";
  if (importType === "merge") {
    firstKey = "recordField";
    secondKey = "mergeField";
  }

  // config.source casing varies by connector ("Bamboo", "paylocity", "CSV") — normalize for stable test ids
  const sourceSlug = kebabCase(String(config?.source || "unknown"));

  const showMergeDupesConfig = importType !== "merge";
  const showSourceMapComposite = showConfiguration || showMergeDupesConfig;
  const explicitShowLoadHeaders = showLoadHeaders || showMergeDupesConfig;

  return (
    <Flex direction={"column"} gap={"12px"} width={"100%"}>
      <Flex direction={"column"} gap={"8px"}>
        {showInputControls && (
          <DataSetupInputComposite
            config={config}
            onChange={onChange}
            size={"medium"}
            doLookup={doInputLookup}
            inputOptions={inputOptions}
            index={index}
          />
        )}
        {postInputControlsNode}
      </Flex>
      {(showAdditionalFields || showCustomFields) && <Divider />}
      <Flex justifyContent={"space-between"} gap={"8px"}>
        {showAdditionalFields && (
          <div style={{ width: "100%" }}>
            <AdditionalTableFieldToggleMenu
              label={appstr("Additional fields")}
              placeholder={appstr("Additional fields")}
              dataTestId={`${DATA_SOURCES_TEST_PREFIX}-${sourceSlug}-additional-fields-menu`}
              config={config}
              allOptions={additionalFieldOptions}
              selectedOptions={selectedAdditionalFields}
              onChange={onAdditionalFieldChange}
            />
          </div>
        )}
        {showCustomFields && (
          <div style={{ width: "100%" }}>
            <AdditionalTableFieldToggleMenu
              label={appstr("Custom fields")}
              dataTestId={`${DATA_SOURCES_TEST_PREFIX}-${sourceSlug}-custom-fields-menu`}
              config={config}
              allOptions={customFieldOptions}
              selectedOptions={selectedCustomFields}
              placeholder={appstr("Select fields")}
              onChange={onCustomFieldChange}
            />
          </div>
        )}
      </Flex>
      {children}
      {showSourceMapComposite && (
        <>
          <Divider />
          <SourceMapComposite
            chartConfig={chartConfig}
            config={config}
            onChange={onChange}
            importType={importType}
            index={index}
            idKey={firstKey}
            superIDkey={secondKey}
            ATSType={ATSType}
            showLoadHeaders={explicitShowLoadHeaders}
            showBasicConfig={showConfiguration}
            showMergeDupesConfig={showMergeDupesConfig}
            {...sourceMapProps}
          />
        </>
      )}
    </Flex>
  );
};
